import iconPersonal from '../assets/goal-icon-personal.png'
import iconWork from '../assets/goal-icon-work.png'
import iconHome from '../assets/goal-icon-home.png'
import heroPersonal from '../assets/goal-hero-personal.png'
import heroWork from '../assets/goal-hero-work.png'
import heroHome from '../assets/goal-hero-home.png'
import type { LifeSpace } from '@/src/renderer/lib/db/models'

/**
 * Per-life-space decorative assets for the Ziele page.
 *
 * `icon` — the small header illustration (top-left, next to the title).
 * `hero` — the large background illustration (bottom-right, empty state only).
 *
 * Titles, descriptions and help copy are NOT here — they are plain i18n keys
 * derived from the life space (`goals.page.<lifeSpace>.*`, `goals.help.*`).
 */
export interface GoalsLifeSpaceAssets {
  icon: string
  hero: string
}

export const GOALS_CONTENT: Record<LifeSpace, GoalsLifeSpaceAssets> = {
  personal: { icon: iconPersonal, hero: heroPersonal },
  work: { icon: iconWork, hero: heroWork },
  home: { icon: iconHome, hero: heroHome },
}
